define('score_bootstrap/Utils/Enums',[], function() {
    "use strict";

    function Enums() {
        
        this.PostCommentActionEnum = {
            Create: 0,
            Edit: 1,
            Delete: 2,
            Restore: 3
        };        
    }

    return new Enums();
});
